import { render, staticRenderFns } from "./ContactColorist.vue?vue&type=template&id=3bdc613f&scoped=true&lang=pug&"
import script from "./ContactColorist.vue?vue&type=script&lang=js&"
export * from "./ContactColorist.vue?vue&type=script&lang=js&"
import style0 from "./ContactColorist.vue?vue&type=style&index=0&id=3bdc613f&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdc613f",
  null
  
)

export default component.exports